module.exports = __webpack_public_path__ + "static/media/country.d493de83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/question-images/country.jpg
// module id = 123
// module chunks = 0